module.exports = __webpack_public_path__ + "static/media/AoA_HomeSections_Bg01.c4118367.jpg";